import request from '@/utils/request'

const url = 'admin/lesson.lesson'
/**
 * 教学排课管理接口API
 */

const api = {
  Query(data) {
    return request({
      url: `${url}/list`,
      method: 'post',
      data
    })
  },

  /**
     * 添加Lesson
     * @returns
     */
  Create(data) {
    return request({
      url: `${url}/createOrUpdate`,
      method: 'post',
      data
    })
  },

  /**
     * 编辑Lesson
     * @returns
     */
  Update(data) {
    return request({
      url: `${url}/createOrUpdate`,
      method: 'post',
      data
    })
  },

  DateAll(data) {
    return request({
      url: `${url}/dateAll`,
      method: 'post',
      data
    })
  },
  DateOne(data) {
    return request({
      url: `${url}/dateOne`,
      method: 'post',
      data
    })
  },

  DatePlan(data) {
    return request({
      url: `${url}/datePlan`,
      method: 'post',
      data
    })
  },
  LastWeekPlan(data) {
    return request({
      url: `${url}/lastWeekPlan`,
      method: 'post',
      data
    })
  },
  CoachList(data) {
    return request({
      url: `${url}/coachList`,
      method: 'post',
      data
    })
  },
  BookList(data) {
    return request({
      url: `${url}/bookList`,
      method: 'post',
      data
    })
  },

  // ---------------------------------------

  oneList(data) {
    return request({
      url: `${url}/oneList`,
      method: 'post',
      data
    })
  },
  saveLesson(data) {
    return request({
      url: `${url}/saveLesson`,
      method: 'post',
      data
    })
  },
  lessonBookInfo(data) {
    return request({
      url: `${url}/lessonBookInfo`,
      method: 'post',
      data
    })
  },
  delLesson(data) {
    return request({
      url: `${url}/delLesson`,
      method: 'post',
      data
    })
  },
  SavePlan(data) {
    return request({
      url: `${url}/savePlan`,
      method: 'post',
      data
    })
  },
  getPlan(data) {
    return request({
      url: `${url}/getPlan`,
      method: 'post',
      data
    })
  },
  siteList(data) {
    return request({
      url: `${url}/siteList`,
      method: 'post',
      data
    })
  },
  getBusinessTime(data) {
    return request({
      url: `${url}/getBusinessTime`,
      method: 'post'
    })
  },
  getAll(data) {
    return request({
      url: `${url}/getAll`,
      method: 'post',
      data
    })
  },
  getBookList(data) {
    return request({
      url: `${url}/getBookList`,
      method: 'post',
      data
    })
  },
  isBook(data) {
    return request({
      url: `${url}/isBook`,
      method: 'post',
      data
    })
  }
}

export default api
